import { faPencil } from '@fortawesome/pro-solid-svg-icons';
import classNames from 'classnames';
import { UncontrolledTooltip } from 'reactstrap';
import { numeralFormatterCurrency } from 'ns_libs/formatter';
import { NSCard, NSButton } from 'bricks';
import RenderIf from 'components/RenderIf/RenderIf';

import './UsesCard.scss';

 
const LOCKED_TOOLTIP_COPY = 'This card is read only. Apply edits in table view once more than one budget line has been added for any of the cards';

interface Props {
    id: string;
    title: string;
    total: number | null | undefined;
    costPerRSF: number | null | undefined;
    supplemental?: string;
    isLocked: boolean;
    isLastCard?: boolean;
    onEnterEdit?: () => void;
}

const UsesCard = ({
    id,
    title,
    total,
    costPerRSF,
    supplemental,
    isLocked,
    isLastCard = false,
    onEnterEdit,
}: Props) => (
    <NSCard
        id={id}
        className={classNames('UsesCard NSCard--level-5 d-flex flex-column rounded-lg p-3', { 'mr-3': !isLastCard })}
    >
        <div className="d-flex align-items-start justify-content-between mb-1">
            <div className="d-flex flex-column">
                <div className="text-dark mb-2">{title}</div>
                <div className="UsesCard__hero text-dark font-24 font-weight-semibold">
                    {total != null && !Number.isNaN(total) ? numeralFormatterCurrency(total, '$0,0') : '—'}
                </div>
            </div>
            <RenderIf isTrue={!isLocked}>
                <NSButton
                    icon={faPencil}
                    size="sm"
                    ariaLabel={`Edit ${title}`}
                    className="p-0"
                    callback={onEnterEdit}
                />
            </RenderIf>
        </div>
        <div className="font-12">
            <span>{costPerRSF != null && !Number.isNaN(costPerRSF) ? `${numeralFormatterCurrency(costPerRSF)} / RSF` : '—'}</span>
            <RenderIf isTrue={Boolean(supplemental)}>
                <span> · {supplemental}</span>
            </RenderIf>
        </div>
        <RenderIf isTrue={isLocked}>
            <UncontrolledTooltip
                target={id}
                placement="top"
                container="body"
                boundariesElement="window"
                positionFixed
            >
                {LOCKED_TOOLTIP_COPY}
            </UncontrolledTooltip>
        </RenderIf>
    </NSCard>
);

export default UsesCard;
